/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import range from 'lodash/range';
import t from 'app/utils/translate';
import SelectField from './SelectField';

type Props = {
  disabled?: boolean,
  defaultText?: string,
  lightContent?: boolean,
  onChange: string => void,
  options: Array<*>,
  required?: boolean,
  size?: string,
  value?: string,
};

const defaultProps = {
  disabled: false,
  defaultText: t('Month'),
  lightContent: false,
  required: false,
  size: 'default',
  value: '',
};

function MonthSelectField({
  disabled,
  defaultText,
  lightContent,
  onChange,
  options,
  required,
  size,
  value,
}: Props) {
  return (
    <SelectField
      disabled={disabled}
      defaultText={defaultText}
      lightContent={lightContent}
      name="month"
      options={options}
      onChange={onChange}
      required={required}
      size={size}
      value={value}
    />
  );
}

MonthSelectField.defaultProps = defaultProps;

function mapStateToProps(state, ownProps) {
  const { language } = state.settings;
  const {
    format = 'MMM',
    options,
  } = ownProps;

  const defaultOptions = range(1, 13).map(m => ({
    label: moment({ month: m - 1 }).locale(language).format(format),
    value: m < 10 ? `0${m}` : m,
  }));

  return {
    options: options || defaultOptions,
  };
}

export default connect(mapStateToProps, null)(MonthSelectField);
